import { Component, OnInit } from '@angular/core';
import { FormBuilder} from '@angular/forms';
import { ApiService } from '../api.service';
@Component({
  selector: 'app-assesment-form-lw',
  templateUrl: './points-submission-form.component.html',
  styleUrls: ['./points-submission-form.component.scss']
})
export class PointSubmissionFormComponent implements OnInit {

  assessmentForm: any = {
    userProfile: ''
  };
  todayDate: string;
  public isRequiredFileUpload:boolean = true;
  public firstName = "";
  public firstNameError = "";
  public lastName = "";
  public lastNameError = "";
  public empId = "";
  public empIdError = "";
  public userProfileError = "";
  public email = "";
  public emailError = "";
  public doe = "";
  public doeError = "";
  public activities = "";
  public activitiesError = "";
  private file;
  public fileError = "";
  public submitted: boolean = false;
  private emailValidation:boolean = false;
  public responseMessage = ''

  public newAssessment: Object = {
  //    "Log any activity": 5 ,
  // "Complete a video class": 20 ,
  // "Join a weekly challenge": 50 ,
  // "Earn badges": 10 ,
  // "Cross 10,000 calories burnt": 100 ,
  // "Cross 25,000 calories burnt": 200 ,

  "Complete an Health assessment": 50 ,
  "Complete a Annual physical with physician": 200 ,
  "Complete a Health screening results with physician": 100,
  "Complete an Eye exam": 200,
  "Complete a Preventive wellness screening": 100,
  "Take a Flu shot": 100
  }


  public newAssessmentkeys = [

  // { name: "Log any activity", point: 5, required: false },
  // { name: "Complete a video class", point: 20, required: false },
  // { name: "Join a weekly challenge", point: 50, required: false },
  // { name: "Earn badges", point: 10, required: false },
  // { name: "Cross 10,000 calories burnt", point: 100, required: false },
  // { name: "Cross 25,000 calories burnt", point: 200, required: false },

  { name: "Complete an Health assessment", point: 50, required: false },
  { name: "Complete a Annual physical with physician", point: 200, required: false },
  { name: "Complete a Health screening results with physician", point: 100, required: false },
  { name: "Complete an Eye exam", point: 200, required: false },
  { name: "Complete a Preventive wellness screening", point: 100, required: false },
  { name: "Take a Flu shot", point: 100, required: false }
  ];
  public mode = '';

  constructor(private fb: FormBuilder, private httpService: ApiService) {
  }

  ngOnInit(): void {
 const today = new Date();
  this.todayDate = today.toISOString().split('T')[0];
  this.assessmentForm.userProfile = '';
  }


  onFileSelected(event) {
    const file: File = event.target.files[0];
    this.file = file;
  }

  checkPoints(e) {
    this.activities = e.target.value;
    this.newAssessmentkeys.map((obj) => {
      if (obj.name == e.target.value) {
        this.isRequiredFileUpload = obj.required;
        if(this.isRequiredFileUpload){
        }else{
          this.file = '';
        }
      }
    });
  }

  submitForm() {
    
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.submitted = true;

    if (this.assessmentForm.hasOwnProperty('firstName')) {
      this.firstNameError = ""
    } else {
      this.firstNameError = "First Name is Required";
    }

    if (this.assessmentForm.hasOwnProperty('lastName')) {
      this.lastNameError = "";
    } else {
      this.lastNameError = "Last Name is Required";
    }
    if (this.assessmentForm.hasOwnProperty('empId')) {
      this.empIdError = "";
    } else {
      this.empIdError = "Employee Id is Required";
    }
    if (this.assessmentForm.hasOwnProperty('userProfile') && this.assessmentForm.userProfile) {
      this.userProfileError = "";
    } else {
      this.userProfileError = "Select User Profile";
    }
    if (this.assessmentForm.hasOwnProperty('doe')) {
      this.doeError = "";
    } else {
      this.doeError = "Date of Exam is Required";
    }

    if (this.assessmentForm.hasOwnProperty('email')) {
      if (!regex.test(this.assessmentForm.email)) {
        this.emailError = "Email is not Valid";
        this.emailValidation = false;
      } else{
        this.emailValidation = true;
        this.emailError = "";
      }
    }
    else {
      this.emailError = "Email is Required";
    }

    if(this.activities != ''){
      this.activitiesError = "";
    }else{
      this.activitiesError = "Select Exam Type";
    }

    if(this.isRequiredFileUpload && this.file == undefined){
      this.fileError = 'File is Required';
    }else if(this.isRequiredFileUpload && this.file == ''){
      this.fileError = 'File is Required';
    }else{
      this.fileError = '';
    }

    if (this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.assessmentForm.hasOwnProperty('userProfile') && this.assessmentForm.userProfile && this.activities != '' && this.file != undefined  && this.file != '' && this.emailValidation) {
      this.callAssessmentFormRequiredApi();
    } 

    if (!this.isRequiredFileUpload && this.assessmentForm.hasOwnProperty('firstName') && this.assessmentForm.hasOwnProperty('lastName') && this.assessmentForm.hasOwnProperty('email') && this.assessmentForm.hasOwnProperty('userProfile') && this.assessmentForm.userProfile && this.activities != '' && this.emailValidation) {
      this.callAssessmentFormNonRequiredApi();
    }
  }


  callAssessmentFormRequiredApi() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("empId",this.assessmentForm.empId);
    formData.append("userProfile",this.assessmentForm.userProfile);
    formData.append("doe",this.assessmentForm.doe);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessment[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file?this.file:'');
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = { userProfile: '' }
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = { userProfile: '' }
      }
    });
  }

  callAssessmentFormNonRequiredApi() {
    this.mode = 'indeterminate';
    let url = "assessment/form";
    const formData = new FormData();
    formData.append("firstName",this.assessmentForm.firstName);
    formData.append("lastName",this.assessmentForm.lastName);
    formData.append("email",this.assessmentForm.email);
    formData.append("empId",this.assessmentForm.empId);
    formData.append("userProfile",this.assessmentForm.userProfile);
    formData.append("doe",this.assessmentForm.doe);
    formData.append("newAssessmentValue",this.activities);
    formData.append("newAssessmentPoint",this.newAssessment[this.activities]);
    formData.append("isFile",this.file?"true":"false");
    formData.append("file",this.file);
    this.httpService.postFormData(url,formData).subscribe(res => {
      if(res['status']){
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = { userProfile: '' }
      }else{
        this.mode = 'determinate';
        this.responseMessage = res.data.message;
        setTimeout(()=>{
          this.responseMessage = ''
        },4000);
        this.assessmentForm = { userProfile: '' }
      }
    });
  }
}
